{
	"closeOption": {
		"title": "Закрытие позиции",
		"sharesPerContract": "х 100 акций",
		"pcs": "шт",
		"quantity": "Количество",
		"side": {
			"buy": "Купить",
			"sell": "Продать"
		},
		"sum": "Сумма",
		"stocks": "Акций",
		"closePosition": "Закрыть позицию",
		"availableMoney": "Доступные средства",
		"orderType": "Тип ордера",
		"price": "Цена",
		"bid": "Bid",
		"ask": "Ask",
		"closeOptionSuccess": "Успешно выставлен ордер на закрытие позиции",
		"closeOptionReject": "Произошла ошибка при закрытии позиции",
		"optionContractDetailReject": "Не удалось получить детали контракта опциона",
		"marketNotOpenedReject": "Дождитесь открытия рынка",
		"closeNotAvailable": "Закрытие позиции Market-ордером сейчас недоступно"
	}
}
